// Vue libs
import 'babel-polyfill';
import 'regenerator-runtime/runtime.js';
import Axios from 'axios';
import Cookies from 'js-cookie';
import QueryString from 'query-string';
import Vue from 'vue';
import Vuex from 'vuex';
import VMediaQuery from 'v-media-query';
import VueLIVR from 'vue-livr';
import 'picturefill';
import VueScrollTo from 'vue-scrollto';
import VueTippy from 'vue-tippy';

import {
	/* eslint-disable camelcase */
	allowed_email_domains,
	allowed_file_extensions,
	allowed_filename_pattern,
	list_length,
	max_date,
	max_file_count,
	max_file_size,
	max_total_file_size,
	min_date,
	phone_number,
	required_if,
	required
	/* eslint-enable camelcase */
} from '../common/livr/livr-extra-rules';

// Click-outside directive
Vue.directive('click-outside', {
	bind: function (element, binding, vnode) {
		element.clickOutsideEvent = function (event) {
			if (!(element == event.target || element.contains(event.target))) {
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', element.clickOutsideEvent);
	},
	unbind: function (element) {
		document.body.removeEventListener('click', element.clickOutsideEvent);
	},
});

// Vue plugins
Vue.use(Vuex);
Vue.use(VMediaQuery);
Vue.use(VueScrollTo);
Vue.use(VueLIVR, {
	extraRules: {
		/* eslint-disable camelcase */
		allowed_email_domains,
		allowed_file_extensions,
		allowed_filename_pattern,
		list_length,
		max_date,
		max_file_count,
		max_file_size,
		max_total_file_size,
		min_date,
		phone_number,
		required,
		required_if
		/* eslint-enable camelcase */
	}
});
Vue.use(VueTippy, {
	theme: 'custom',
	directive: 'tippy',
	arrow: true,
	placement: 'top',
	interactive: true
});

// Utils
import {LANGUAGES} from '../common/utils/constants';

// Filters
Vue.filter('dateFormat', function (date) {
	let formattedDate = '';
	const {lang} = window;

	if (date && lang) {
		// hu-HU: yyyy-MM-dd -> yyyy. MMMM dd.
		// en-GB: yyyy-MM-dd -> dd MMMM yyyy
		const locale = lang === LANGUAGES.HU ? 'hu-HU' : 'en-GB';
		return new Date(date).toLocaleDateString(locale, {year: 'numeric', month: 'long', day: 'numeric'});
	}

	return formattedDate;
});

// global objects
window.Vue = Vue;
window.Vuex = Vuex;
window.Axios = Axios;
window.Cookies = Cookies;
window.QueryString = QueryString;
window.EventBus = new Vue();



// WEBPACK FOOTER //
// ../source/build-entry/libs.js